const options = { style: 'percent', maximumFractionDigits: 2 };

function formatPercentage(number: number, locale = 'de-DE') {
    return Intl.NumberFormat(locale, options).format(number);
}

export default formatPercentage;
